export const getFilterOverlayVisible = (state) =>
  state.layout.isFilterOverlayVisible;

export const getFilterButtonFocused = (state) =>
  state.layout.isFilterButtonFocused;

export const getSortOverlayVisible = (state) =>
  state.layout.isSortOverlayVisible;

export const getViewportCategory = (state) => state.layout.viewportCategory;

export const getClientWidth = (state) => state.layout.clientWidth;

export const getSuccessMessage = (state) => state.layout.successMessage;

export const getSecondaryListIsOpen = (state) =>
  state.layout.isSecondaryListVisible;

export const getDetectedFloor = (state) => state.layout.detectedFloor;
